module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Direction2-ceaaf86b1e7ecd31422c6f0ef0ddaba5.svg";